<template>
  <div>
    <md-card v-for="point in points" :key="point.id">
      <md-card-header :data-background-color="dataBackgroundColor">
        <h4 class="title">{{ point.plan_name }}</h4>
        <p class="category">{{ point.address }}</p>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-60">
            <md-field>
              <label>Programação</label>
              <md-input :value="point.plan_name" disabled></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Mensalidade</label>
              <md-input
                :value="
                  formatMoney(
                    point.price + point.additionPrice - point.discountPrice
                  )
                "
                disabled
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-30">
            <md-field>
              <label>Situação</label>
              <md-input :value="formatStatus(point.status)" disabled></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-70">
            <md-field>
              <label>Endereço</label>
              <md-input :value="formatAddress(point)" disabled></md-input>
            </md-field>
          </div>
        </div>
        <!--
        <router-link
          :to="{
            name: 'Atualização de Plano',
            query: { planId: point.plan_id }
          }"
          tag="button"
          >Atualizar Plano</router-link
        >
        -->
      </md-card-content>
    </md-card>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { formatStatus, formatMoney, formatAddress } from "@/helpers";

export default {
  name: "service-form",
  props: {
    dataBackgroundColor: {
      type: String,
      default: "primary"
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    points() {
      return this.$store.getters.points;
    }
  },
  methods: {
    ...mapActions(["fetchPoints"]),
    formatStatus,
    formatMoney,
    formatAddress
  },
  async mounted() {
    await this.fetchPoints({ id: this.user.id });
  }
};
</script>
<style>
button {
  border: none;
  border-radius: 3px;
  background: #0f7585;
  color: #fff;
  padding: 8px 20px;
}
</style>
